import React, { useEffect, useState } from "react";
import { Container, Col, Row, Button, Form } from "react-bootstrap";
import _ from "lodash";

import { PersonalChart } from "../../components/PersonalChart";
import { ReactRegisterModal } from "../RegisterForm/components/ReactRegisterModal";
import { CalculatorField } from "components/CalcComponents/CalculatorField";
import useCalc from "hooks/useCalc";
import downTack from "assets/img/down-tack.png";
import recyclingIcon from "assets/img/recycling-icon.png";

import "./style.scss";

const INPUT_FIELDS = ["psycho", "maturity"];

export const AcceptanceChances = ({ labels }) => {
  const [thisYearDecision, setThisYearDescision] = useState("");
  const [lastYearDecision, setLastYearDecision] = useState("");
  const [checkBox, setCheckBox] = useState(false);
  const {
    buildJsonAndCallLastScore,
    scoresData,
    formFields,
    handleChange,
    validate,
    checkIfInvalid,
    resetCalc,
    showResult,
    handleSaveToPersonal,
    showRegister,
    setShowRegister
  } = useCalc(labels, INPUT_FIELDS);

  const linkRequirements = window.location.href.split('?')[0] + "?v=admission-requirements";
  const showAcceptanceDecision = labels.field_this_year_receipt_threshol && labels.field_this_year_rejection_thresh
    && labels.field_last_year_receipt_threshol && labels.field_last_year_rejection_thresh;
  const showAcceptanceDecisionCurrentYear = labels.field_this_year_receipt_threshol && labels.field_this_year_rejection_thresh;
  const calcAcceptanceDecision = (studentAdapter, acceptanceScore, rejectionScore) => {
    if (studentAdapter >= acceptanceScore) {
      return <p tabIndex="0" className="acceptance-decision accepted">{labels.accepted}</p>;
    }
    if (studentAdapter < rejectionScore) {
      return <p tabIndex="0" className="acceptance-decision rejected">{labels.rejected}</p>;
    }
    return <p tabIndex="0" className="acceptance-decision didnt-decide">{labels.didnt_decide}</p>;
  }

  const findAcceptanceDecisionForThisYearAndLastYear = (studentAdapter) => {
    const thisYearThresholds = {
      acceptanceScore: parseInt(labels.field_this_year_receipt_threshol),
      rejectionScore: parseInt(labels.field_this_year_rejection_thresh)
    }
    const lastYearThresholds = {
      acceptanceScore: parseInt(labels.field_last_year_receipt_threshol),
      rejectionScore: parseInt(labels.field_last_year_rejection_thresh)
    }
    if (studentAdapter) {
      setThisYearDescision(calcAcceptanceDecision(studentAdapter, thisYearThresholds.acceptanceScore, thisYearThresholds.rejectionScore));
      setLastYearDecision(calcAcceptanceDecision(studentAdapter, lastYearThresholds.acceptanceScore, lastYearThresholds.rejectionScore));
    }
  }

  const resetCalcAndDecisions = () => {
    resetCalc();
    setThisYearDescision("");
    setLastYearDecision("");
  }

  const calculateScore = () => {
    const jsonParams = {};
    jsonParams.psycho = formFields.psycho;
    jsonParams.maturity = formFields.maturity;
    jsonParams.chug = labels.field_external_department_id;
    checkBox ? jsonParams.reali10 = 1 : 0;
    buildJsonAndCallLastScore(jsonParams);
  }

  const handleClickCalcBtn = () => {
    if (validate()) {
      calculateScore();
    }
  }

  useEffect(() => {
    if (showResult) {
      findAcceptanceDecisionForThisYearAndLastYear(scoresData?.getLastScore?.body?.hatama);
    }
  }, [showResult])

  const getAccessibleTitle = () => {
    let accessibleSemesterLabel = labels.semester_label;
    if (accessibleSemesterLabel?.[-1] === "א") {
      accessibleSemesterLabel = accessibleSemesterLabel.slice(0, -1) + labels.letterAForAccessibility;
    } else if (accessibleSemesterLabel?.[-1] === "ב") {
      accessibleSemesterLabel = accessibleSemesterLabel.slice(0, -1) + labels.letterBForAccessibility;
    }
    return `${labels.title}${accessibleSemesterLabel}`
  }

  return (
    <>
      {
        labels.field_this_year_rejection_thresh && labels.field_this_year_receipt_threshol ?

          <Container fluid className="acceptance-chance p-0">
            <div className="outer-box">
              <Row>
                <Col xs={12} md={5} className="right-half">
                  <h2 tabIndex="0" className="title" aria-label={getAccessibleTitle()}>{labels.title}{labels.semester_label}'</h2>
                  {labels.field_this_year_receipt_threshol && labels.field_this_year_rejection_thresh && (
                    <div className="indexing">
                      <Row tabIndex="0" aria-labelledby="acceptanceLabel acceptanceThreshold">
                        <span id="acceptanceLabel" className="acceptance acceptance-label">{labels.last_mitam}</span>
                        <span id="acceptanceThreshold" className="acceptance">{labels.field_this_year_receipt_threshol}</span>
                      </Row>
                      <Row tabIndex="0" aria-labelledby="rejectionLabel rejectionThreshold">
                        <span id="rejectionLabel" className="rejection-label"> {labels.rejection}</span>
                        <span id="rejectionThreshold">{labels.field_this_year_rejection_thresh}</span>
                      </Row>
                    </div>
                  )}
                  <Row className="justify-content-sm-center chart-wrapper">
                    <PersonalChart
                      labels={labels}
                      rejectionScore={labels.field_this_year_rejection_thresh}
                      acceptanceScore={labels.field_this_year_receipt_threshol}
                      calcScore={showResult ? formFields.adapter : undefined}
                      width={Utils.isMobile() ? "48.1em" : "33em"}
                      height={Utils.isMobile() ? "20em" : "19.5em"}
                      info={true}
                      border={'hide'}
                    />
                  </Row>
                  <a className="link-requirements" href={linkRequirements} > {labels.linkRequirements} </a>
                </Col>
                <Col md="auto" className="left-half">
                  <Row className="left-half-first-row justify-content-sm-around justify-content-md-start">
                    <Col sm={12} md="auto" className="first-row-first-col p-0">
                      <div className="form-and-header-wrap">
                        <h4 tabIndex="0">{labels.whats_your_chance}</h4>
                        <div className="form-wrapper">
                          <CalculatorField
                            title={labels.psycho}
                            errMsg={labels.psychometricError}
                            fieldName="psycho"
                            handleChange={handleChange}
                            fieldValue={formFields.psycho}
                            fieldInvalid={checkIfInvalid("psycho")}
                          />
                          {checkIfInvalid("psycho") ? (
                            <span aria-label={labels.psychoError} tabIndex="0" className="text-danger">{labels.psychoError}</span>
                          ) : null
                          }
                          <CalculatorField
                            title={labels.matriculation}
                            errMsg={labels.maturityError}
                            fieldName="maturity"
                            handleChange={handleChange}
                            fieldValue={formFields.maturity}
                            fieldInvalid={checkIfInvalid("maturity")}
                            className="maturity-group"
                          />
                          {checkIfInvalid("maturity") ? (
                            <span aria-label={labels.maturityError} tabIndex="0" className="text-danger maturity-text-danger">{labels.maturityError}</span>
                          ) : null
                          }
                        </div>
                      </div>
                      {labels.starts_with_specific_numbers && (
                        <div className="have-math-physics">
                          <Form.Group controlId="formMathPhysics">
                            <Form.Check type="checkbox" defaultChecked={checkBox} label={labels.haveMathPhysics} id="haveMathPhysics" aria-labelledby="haveMathPhysics" onChange={(e) => { e.target.checked ? setCheckBox(true) : setCheckBox(false); }} />
                          </Form.Group>
                        </div>
                      )}
                      <Button
                        disabled={showResult}
                        className={`calc ${showResult ? 'disabled' : ""}`}
                        variant="dark"
                        onClick={handleClickCalcBtn}
                      >
                        {labels.calculate}
                      </Button>
                    </Col>
                    {showResult && (
                      <Col sm={12} md={6} className={`score-and-action-btns-wrapper px-0`}>
                        <Row className="justify-content-sm-around justify-content-md-start">
                          <Col sm={5} md={4} className="adapter-wrapper px-0">
                            <p className="decision-label" tabIndex="0">{labels.yourAdapter}</p>
                            <p className="adapter-score" tabIndex="0">{formFields.adapter}</p>
                          </Col>
                          <Col sm={5} md={4} className="current-decision-col p-0">
                            <p tabIndex="0" className="decision-label this-year">{labels.current_decision}</p>
                            <div>{showAcceptanceDecisionCurrentYear ? thisYearDecision : ""}</div>
                          </Col>
                          <Col sm={5} md={4} className={"last-year-decision-col p-0"}>
                            {showAcceptanceDecision && <>
                              <p tabIndex="0" className="decision-label last-year">{labels.last_year}</p>
                              <div>{showAcceptanceDecision ? lastYearDecision : ""}</div>
                            </>}
                          </Col>
                          <Col sm={12} md={{ order: 5 }} className="action-btns px-0 d-md-flex">
                            <button
                              className="calc-action-btn"
                              onClick={handleSaveToPersonal}
                            >
                              <img src={downTack} alt="down-tack" className="action-btn-icon" />
                              {labels.save_to_personal}
                            </button>
                            <button
                              className="calc-action-btn"
                              id="calcAgainBtn"
                              onClick={() => resetCalcAndDecisions()}
                            >
                              <img src={recyclingIcon} alt="recycling Icon" className="action-btn-icon" />
                              {labels.recalculate}
                            </button>
                          </Col>
                        </Row>
                      </Col>
                    )}
                  </Row>
                </Col>
              </Row>
            </div>
            <ReactRegisterModal
              show={showRegister}
              setShow={setShowRegister}
              labels={labels.RegisterForm.labels}
              lastAction={{
                action: handleSaveToPersonal
              }}
            />
          </Container>
          : <></>}
    </>
  );
};
